import { render, staticRenderFns } from "./PageHome.vue?vue&type=template&id=9e799ed8&"
import script from "./PageHome.vue?vue&type=script&lang=js&"
export * from "./PageHome.vue?vue&type=script&lang=js&"
import style0 from "./PageHome.vue?vue&type=style&index=0&id=9e799ed8&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e799ed8')) {
      api.createRecord('9e799ed8', component.options)
    } else {
      api.reload('9e799ed8', component.options)
    }
    module.hot.accept("./PageHome.vue?vue&type=template&id=9e799ed8&", function () {
      api.rerender('9e799ed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/PageHome.vue"
export default component.exports